module.exports = __webpack_public_path__ + "img/currents-providers.82f8008.webp";